<template>
  <div class="navbar">
    <!--vs-button v-on:click="active=true" color="primary" type="filled">Open Sidebar</vs-button>
    <vs-button v-on:click="active=false" color="primary" type="filled">Close Sidebar</vs-button-->
    <vs-button v-on:click="active=!active" icon="menu" id="menu_button"></vs-button>
    <vs-sidebar :click-not-close="true" :reduce="reduce" parent="body" default-index="0" :hidden-background="true" color="success" class="sidebarx" v-model="active">

      <div class="header-sidebar" slot="header">
        <vs-avatar size="70px" :src="user_logo"/><!--TODO: cambiare immagine-->
        <p v-if="userData.impersona.stato">{{userData.impersona.denominazione}}</p>
      </div>
      
      <vs-sidebar-item index="0" icon="exit_to_app" to="#" v-on:click="deimpersonaInstallatore()" v-if="userData.impersona.stato">
        Chiudi installatore
      </vs-sidebar-item>

      <vs-divider position="left" v-if="userData.impersona.stato"></vs-divider>

      <vs-sidebar-item index="1" icon="home" to="/">
        Home
      </vs-sidebar-item>

      <vs-divider position="left"></vs-divider>

      <vs-sidebar-group open title="Installatori" v-if="(stato.consulente || stato.azienda) && !stato.installatore && !stato.admin">
        <vs-sidebar-item index="2" icon="build" to="/installatori">
          Lista installatori
        </vs-sidebar-item>
        <vs-sidebar-item index="3" icon="playlist_add" to="/installatori/aggiungi">
          Aggiungi installatore
        </vs-sidebar-item>
      </vs-sidebar-group>

      <vs-sidebar-group open title="Clienti" v-if="stato.installatore">
        <vs-sidebar-item index="4" icon="assignment_ind" to="/clienti">
          Lista clienti
        </vs-sidebar-item>
        <vs-sidebar-item index="5" icon="playlist_add" to="/clienti/aggiungi">
          Aggiungi cliente
        </vs-sidebar-item>
      </vs-sidebar-group>

      <vs-sidebar-group open title="Macchine" v-if="stato.installatore">
        <vs-sidebar-item index="6" icon="settings_applications" to="/macchine">
          Lista macchine
        </vs-sidebar-item>
        <vs-sidebar-item index="7" icon="playlist_add" to="/macchine/aggiungi">
          Aggiungi macchina
        </vs-sidebar-item>
      </vs-sidebar-group>

      <vs-sidebar-group open title="Utenti" v-if="stato.admin">
        <vs-sidebar-item index="23" icon="build" to="/utenti/installatori">
          Installatori
        </vs-sidebar-item>
        <vs-sidebar-item index="24" icon="assignment_ind" to="/utenti/consulenti">
          Consulenti
        </vs-sidebar-item>
        <vs-sidebar-item index="25" icon="business" to="/utenti/aziende">
          Aziende
        </vs-sidebar-item>
      </vs-sidebar-group>

      <vs-sidebar-group open title="Amministratore" v-if="stato.admin">
        <vs-sidebar-item index="20" icon="ballot" to="/admin/modelli">
          Modelli documenti tecnici
        </vs-sidebar-item>
      </vs-sidebar-group>

      <vs-sidebar-group title="Elenchi" v-if="stato.installatore || stato.admin">
        <vs-sidebar-item index="8" icon="ballot" to="/elenco/marche">
          Marche
        </vs-sidebar-item>
        <vs-sidebar-item index="9" icon="build" to="/elenco/costruttori">
          Costruttori
        </vs-sidebar-item>
        <vs-sidebar-item index="10" icon="dvr" to="/elenco/componenti">
          Componenti
        </vs-sidebar-item>
        <vs-sidebar-item index="11" icon="settings_input_composite" to="/elenco/tipoelettrico">
          Tipo alimentazione elettrica
        </vs-sidebar-item>
        <vs-sidebar-item index="12" icon="all_inbox" to="/elenco/tipocomponente">
          Tipologia Componente
        </vs-sidebar-item>
        <vs-sidebar-item index="13" icon="dns" to="/elenco/sottotipocomponente">
          Sottotipologia Componente
        </vs-sidebar-item>
        <vs-sidebar-item index="14" icon="developer_board" to="/elenco/tipomanufatto">
          Tipologia Manufatto
        </vs-sidebar-item>
        <vs-sidebar-item index="15" icon="loyalty" to="/elenco/tipoutilizzo">
          Tipologia Utilizzo
        </vs-sidebar-item>
        <vs-sidebar-item index="16" icon="card_membership" to="/elenco/tipouso">
          Tipologia Uso Previsto
        </vs-sidebar-item>
        <vs-sidebar-item index="17" icon="extension" to="/elenco/tipotamponamento">
          Tipologia Tamponamento
        </vs-sidebar-item>
        <vs-sidebar-item index="18" icon="how_to_reg" to="/elenco/tipocliente">
          Tipologia Cliente
        </vs-sidebar-item>
        <vs-sidebar-item index="19" icon="place" to="/elenco/tipoluogo">
          Tipologia Luogo Installazione
        </vs-sidebar-item>
        <vs-sidebar-item index="20" icon="router" to="/elenco/tipomacchina">
          Tipologia Macchina
        </vs-sidebar-item>
      </vs-sidebar-group>

      <vs-divider position="left" icon="account_circle"></vs-divider>

      <!--TODO: ricontrollare index di logout e chiudi sidebar-->
      <vs-sidebar-item index="21" icon="close" v-on:click="active = !active">
        Chiudi barra
      </vs-sidebar-item>
      <vs-sidebar-item index="22" icon="exit_to_app" style="color: red" v-on:click="logout">
        Esci
      </vs-sidebar-item>

      <div class="footer-sidebar" slot="footer">
        <vs-button icon="invert_colors" color="primary" type="border" v-on:click="reduce = !reduce"></vs-button>
        <vs-button v-if="(stato.consulente && !stato.installatore) || (!stato.consulente && stato.installatore)" icon="settings" color="primary" type="border" to="/impostazioni"></vs-button>
      </div>

    </vs-sidebar>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    name: 'navbar',
    data() {
      return {
        active: true,
        reduce: false,
      }
    },
    created: function(){
      this.getInfoImpersona()
      if((screen.width-1140)/2-260 > 20)
        this.reduce = false
      else{
        this.reduce = true        
        if(screen.width < 1270)
          this.active = false
      }
    },
    methods: {
      ...mapMutations(['impersona']),
      ...mapActions(['updateUserStatus']),

      logout() {
        Vue.http.post('user/logout', {}, {credentials : true}).then(response => {
          if(response.body.success){
            /*Vue.notify({
              group: 'global',
              title: 'Operazione eseguita',
              text: 'Utente uscito con successo!',
              type: 'success'
            })*/
            location.reload()
          }
        }, response => {})
      },
      toggle(){
        Vue.prototype.$sidebar.stato = !this.$sidebar.stato 
        this.$emit('input', this.$sidebar)
      },
      deimpersonaInstallatore(){
        Vue.http.post('installatore/disimpersona/', {}, {credentials : true}).then(async response => {
          if(response.body.success){
            await this.updateUserStatus()
            this.getInfoImpersona()
            localStorage.removeItem("todo_list")
            var oldPath = this.$router.history.current.path
            this.$router.push('/')
            if(oldPath == "/")
              this.$router.go()

            Vue.notify({
                group: 'global',
                title: 'Operazione eseguita!',
                text: "Non si sta controllando nessun installatore!",
                type: 'success'
            })
          }else{
            Vue.notify({
                group: 'global',
                title: 'Errore',
                text: response.body.msg,
                type: 'error'
            })
          }
        }, response => {})
      },
      getInfoImpersona(){
        if(this.stato.consulente){
          Vue.http.post('installatore/infoimpersona', {}, {credentials : true}).then(response => {
            if(response.body.success){
              this.impersona({stato: response.body.stato, denominazione: response.body.denominazione})
            }
          }, response => {})
        }
      },
    },
    computed: {
      ...mapGetters(['stato', 'userData']),
      user_logo() {
        return require('../assets/user.jpeg')
      }
    }
}
</script>

<style>
.header-sidebar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
}
.header-sidebar h4 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.header-sidebar h4 > button {
  margin-left: 10px;
}
.footer-sidebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.footer-sidebar > button {
  border: 0px solid rgba(0,0,0,0) !important;
  border-left: 1px solid rgba(0,0,0,0.07) !important;
  border-radius: 0px !important;
}

#menu_button{
  position: fixed;
  top: 10px;
  left: 0px;
  /*background-color: white !important;
  color: black;*/
  border-radius: 0 !important;
  border-radius: 0 5px 5px 0 !important;
  z-index: 1;
  background-image: linear-gradient(to right, #493240, #493240) !important;
}
</style>